import { docEntityBaseNew } from "building-types/entities/docEntityBaseNew";
import type { Label } from "building-types/entities/labelTypes";
import uid from "common/utils/uid";

export function labelNew({ id = uid(), name = "Label" }: Partial<Label>): Label {
  return {
    ...docEntityBaseNew("LABEL"),
    id,
    name,
  };
}
